/**
 * URL Helper Functions for Correspondence
 * These are not server actions, just simple URL generators
 */

import { BACKEND_ENDPOINTS } from './api/endpoints';

/**
 * Get letter preview URL
 */
export function getLetterPreviewUrlAction(
  matterId: number,
  correspondenceId: number
): string {
  return `/api/proxy${BACKEND_ENDPOINTS.previewLetter(matterId, correspondenceId)}`;
}

/**
 * Get collection documents URL
 */
export function getCollectionDocumentsUrlAction(
  matterId: number,
  correspondenceId: number
): string {
  return `/api/proxy${BACKEND_ENDPOINTS.printPackage(matterId, correspondenceId)}`;
}
